module.exports = __webpack_public_path__ + "product/icon-contact-97e25d75211385b746cc5badf987b434.svg";